var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"container",staticClass:"fixed-container",staticStyle:{"width":"100%","height":"60vh","overflow":"hidden"}})
}
var staticRenderFns = []

export { render, staticRenderFns }